// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-container {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 5px;
  flex-direction: row;
  position: relative;
  margin-bottom: 24px;
}
.tag-container.no-margin {
  margin-bottom: 0;
}

.tag {
  background-color: #e0e0e0;
  border-radius: 3px;
  padding: 5px;
  margin: 2px;
  display: flex;
  align-items: center;
  width: fit-content;
}

.close {
  cursor: pointer;
  font-weight: bold;
  margin-left: 5px;
}

.tag-input {
  border: none;
  outline: none;
  flex: 1 1;
}

.tag-line {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.input-error {
  border: 1px solid red;
}`, "",{"version":3,"sources":["webpack://./src/components/InputEmailField/InputEmailField.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAAF;;AAGA;EACE,qBAAA;AAAF","sourcesContent":[".tag-container {\n  display: flex;\n  flex-wrap: wrap;\n  border: 1px solid #ccc;\n  padding: 5px;\n  border-radius: 5px;\n  flex-direction: row;\n  position: relative;\n  margin-bottom: 24px;\n\n  &.no-margin {\n    margin-bottom: 0;\n  }\n}\n\n.tag {\n  background-color: #e0e0e0;\n  border-radius: 3px;\n  padding: 5px;\n  margin: 2px;\n  display: flex;\n  align-items: center;\n  width: fit-content;\n}\n\n.close {\n  cursor: pointer;\n  font-weight: bold;\n  margin-left: 5px;\n}\n\n.tag-input {\n  border: none;\n  outline: none;\n  flex: 1;\n}\n\n.tag-line {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.input-error {\n  border: 1px solid red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
